<template lang="pug">
  el-form(:class="{container: container}" ref="form" :model="form")
    el-form-item(prop="comment"
      :rules="rules")
      el-input.lei-input(
        v-model="form.comment"
        type="textarea"
        placeholder="Add comment"
        :autosize="{minRows: minRow, maxRows: 11}")

</template>

<script>
import throttle from 'lodash/throttle'

export default {
  name: 'CommentInput',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 255,
    },
    minRow: {
      type: Number,
      default: 4,
    },
    container: {
      type: Boolean,
      default: true,
    },
    cancel: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        comment: '',
      },
    }
  },
  computed: {
    comment () {
      return this.form.comment
    },
    rules () {
      let result = []
      if (this.required) {
        result.push({
          required: true,
          message: 'Comment is required.',
        })
      }
      result.push({
        max: this.max,
        message: `Comment is too long! Maximum ${this.max} characters.`,
        trigger: 'change',
      })
      return result
    },
  },
  watch: {
    comment () {
      this.validateAndEmit()
    },
    cancel () {
      if (this.cancel) this.form = {
        comment: '',
      }
    },
    rules () {
      this.validateAndEmit()
      setTimeout(() => {
        this.validateAndEmit()
      }, 200)
    },
  },
  methods: {
    validateAndEmit: throttle(function () {
      this.$refs.form.validate((valid) => {
        this.$emit('input', {
          value: this.comment,
          valid: valid,
        })
      })
    }, 500),
  },
}
</script>

<style scoped lang="stylus">
  .el-form-item
    width 100%
    margin 0

</style>



// WEBPACK FOOTER //
// src/components/lei-components/inputs/CommentInput.vue